import React from 'react';

export const JiraAppSelectorIcon = (): React.JSX.Element => (
	<svg
		role="presentation"
		width="42"
		height="16"
		viewBox="0 0 42 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<mask id="path-1-inside-1_411_4616" fill="white">
			<path d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z" />
		</mask>
		<path
			d="M26 4C26 1.79086 27.7909 0 30 0H38C40.2091 0 42 1.79086 42 4V12C42 14.2091 40.2091 16 38 16H30C27.7909 16 26 14.2091 26 12V4Z"
			fill="white"
		/>
		<path
			d="M30 0V1H38V0V-1H30V0ZM42 4H41V12H42H43V4H42ZM38 16V15H30V16V17H38V16ZM26 12H27V4H26H25V12H26ZM30 16V15C28.3431 15 27 13.6569 27 12H26H25C25 14.7614 27.2386 17 30 17V16ZM42 12H41C41 13.6569 39.6569 15 38 15V16V17C40.7614 17 43 14.7614 43 12H42ZM38 0V1C39.6569 1 41 2.34315 41 4H42H43C43 1.23858 40.7614 -1 38 -1V0ZM30 0V-1C27.2386 -1 25 1.23858 25 4H26H27C27 2.34315 28.3431 1 30 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-1-inside-1_411_4616)"
		/>
		<g clipPath="url(#clip0_411_4616)">
			<path
				d="M31.1422 9.29926C31.1422 9.87406 30.6777 10.3386 30.1029 10.3386C29.5281 10.3386 29.0635 9.87406 29.0635 9.29926C29.0635 8.72445 29.5281 8.25989 30.1029 8.25989H31.1422V9.29926ZM31.6619 9.29926C31.6619 8.72445 32.1265 8.25989 32.7013 8.25989C33.2761 8.25989 33.7407 8.72445 33.7407 9.29926V11.8977C33.7407 12.4725 33.2761 12.9371 32.7013 12.9371C32.1265 12.9371 31.6619 12.4725 31.6619 11.8977V9.29926Z"
				fill="#E01E5A"
			/>
			<path
				d="M32.7014 5.12598C32.1266 5.12598 31.662 4.66141 31.662 4.08661C31.662 3.51181 32.1266 3.04724 32.7014 3.04724C33.2762 3.04724 33.7408 3.51181 33.7408 4.08661V5.12598H32.7014ZM32.7014 5.65354C33.2762 5.65354 33.7408 6.11811 33.7408 6.69291C33.7408 7.26771 33.2762 7.73228 32.7014 7.73228H30.0951C29.5203 7.73228 29.0557 7.26771 29.0557 6.69291C29.0557 6.11811 29.5203 5.65354 30.0951 5.65354H32.7014Z"
				fill="#36C5F0"
			/>
			<path
				d="M36.8666 6.69291C36.8666 6.11811 37.3311 5.65354 37.9059 5.65354C38.4807 5.65354 38.9453 6.11811 38.9453 6.69291C38.9453 7.26771 38.4807 7.73228 37.9059 7.73228H36.8666V6.69291ZM36.3469 6.69291C36.3469 7.26771 35.8823 7.73228 35.3075 7.73228C34.7327 7.73228 34.2681 7.26771 34.2681 6.69291V4.08661C34.2681 3.51181 34.7327 3.04724 35.3075 3.04724C35.8823 3.04724 36.3469 3.51181 36.3469 4.08661V6.69291Z"
				fill="#2EB67D"
			/>
			<path
				d="M35.3075 10.8583C35.8823 10.8583 36.3469 11.3229 36.3469 11.8977C36.3469 12.4725 35.8823 12.9371 35.3075 12.9371C34.7327 12.9371 34.2681 12.4725 34.2681 11.8977V10.8583H35.3075ZM35.3075 10.3386C34.7327 10.3386 34.2681 9.87406 34.2681 9.29926C34.2681 8.72445 34.7327 8.25989 35.3075 8.25989H37.9138C38.4886 8.25989 38.9532 8.72445 38.9532 9.29926C38.9532 9.87406 38.4886 10.3386 37.9138 10.3386H35.3075Z"
				fill="#ECB22E"
			/>
		</g>
		<mask id="path-7-inside-2_411_4616" fill="white">
			<path d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z" />
		</mask>
		<path
			d="M13 4C13 1.79086 14.7909 0 17 0H25C27.2091 0 29 1.79086 29 4V12C29 14.2091 27.2091 16 25 16H17C14.7909 16 13 14.2091 13 12V4Z"
			fill="white"
		/>
		<path
			d="M17 0V1H25V0V-1H17V0ZM29 4H28V12H29H30V4H29ZM25 16V15H17V16V17H25V16ZM13 12H14V4H13H12V12H13ZM17 16V15C15.3431 15 14 13.6569 14 12H13H12C12 14.7614 14.2386 17 17 17V16ZM29 12H28C28 13.6569 26.6569 15 25 15V16V17C27.7614 17 30 14.7614 30 12H29ZM25 0V1C26.6569 1 28 2.34315 28 4H29H30C30 1.23858 27.7614 -1 25 -1V0ZM17 0V-1C14.2386 -1 12 1.23858 12 4H13H14C14 2.34315 15.3431 1 17 1V0Z"
			fill="#0B1228"
			fillOpacity="0.14"
			mask="url(#path-7-inside-2_411_4616)"
		/>
		<g clipPath="url(#clip1_411_4616)">
			<path
				d="M16.4728 11.3856L16.9432 12.194C17.041 12.3641 17.1815 12.4978 17.3464 12.5951L19.0264 9.70203H15.6664C15.6664 9.89044 15.7153 10.0789 15.813 10.249L16.4728 11.3856Z"
				fill="#0066DA"
			/>
			<path
				d="M20.9997 6.29834L19.3197 3.40527C19.1547 3.50252 19.0142 3.63623 18.9165 3.80641L15.813 9.15494C15.7171 9.32145 15.6665 9.51002 15.6664 9.70195H19.0264L20.9997 6.29834Z"
				fill="#00AC47"
			/>
			<path
				d="M24.6534 12.5951C24.8183 12.4978 24.9588 12.3641 25.0566 12.194L25.2521 11.8597L26.1868 10.249C26.2845 10.0789 26.3334 9.89044 26.3334 9.70203H22.9731L23.6881 11.0999L24.6534 12.5951Z"
				fill="#EA4335"
			/>
			<path
				d="M21 6.29846L22.68 3.40539C22.5151 3.30814 22.3257 3.25952 22.1302 3.25952H19.8698C19.6743 3.25952 19.4849 3.31422 19.3199 3.40539L21 6.29846Z"
				fill="#00832D"
			/>
			<path
				d="M22.9727 9.70203H19.0262L17.3461 12.5951C17.5111 12.6923 17.7005 12.741 17.896 12.741H24.1029C24.2984 12.741 24.4878 12.6863 24.6527 12.5951L22.9727 9.70203Z"
				fill="#2684FC"
			/>
			<path
				d="M24.6352 6.48068L23.0834 3.80641C22.9857 3.63623 22.8452 3.50252 22.6802 3.40527L21.0002 6.29834L22.9735 9.70195H26.3274C26.3274 9.51353 26.2785 9.32512 26.1808 9.15494L24.6352 6.48068Z"
				fill="#FFBA00"
			/>
		</g>
		<mask
			id="path-15-outside-3_411_4616"
			maskUnits="userSpaceOnUse"
			x="0"
			y="0"
			width="17"
			height="16"
			fill="black"
		>
			<rect fill="white" width="17" height="16" />
			<path d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z" />
		</mask>
		<path
			d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
			fill="#1868DB"
		/>
		<path
			d="M0 0H16H0ZM16 16H0H16ZM0 16V0V16ZM12 0C14.7614 0 17 2.23858 17 5V11C17 13.7614 14.7614 16 12 16C13.6569 16 15 14.2091 15 12V4C15 1.79086 13.6569 0 12 0Z"
			fill="white"
			mask="url(#path-15-outside-3_411_4616)"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M4.27268 4.29895C4.09939 4.66482 3.85618 5.18269 3.73216 5.44985L3.50662 5.93552L5.01882 6.65669C6.97255 7.58839 7.08061 7.633 7.68635 7.75812C8.31815 7.88863 8.64861 7.88918 9.25981 7.76092C10.3578 7.5304 11.3469 6.79524 12.0927 5.6556C12.3169 5.31299 12.5002 5.0019 12.5 4.96425C12.4994 4.85707 10.3872 3.6037 10.3256 3.67404C10.2956 3.70815 10.1268 3.95702 9.95035 4.22698C9.44872 4.99447 9.04484 5.27117 8.42628 5.27104C8.15087 5.27097 7.83125 5.14353 6.37424 4.45238C5.42508 4.00219 4.6348 3.63379 4.61808 3.63379C4.60137 3.63379 4.44589 3.93308 4.27268 4.29895ZM6.72033 8.23492C5.59365 8.49191 4.59086 9.30041 3.78223 10.6039L3.5 11.0588L3.8216 11.2616C4.74354 11.8429 5.62033 12.3661 5.67224 12.3661C5.70444 12.3661 5.85508 12.1571 6.0068 11.9016C6.33222 11.3539 6.78153 10.917 7.1416 10.7981C7.6388 10.6341 7.94927 10.7271 9.71921 11.5709C10.6367 12.0083 11.4023 12.3661 11.4205 12.3661C11.5023 12.3661 12.5181 10.1057 12.4608 10.0515C12.3259 9.92395 9.19029 8.47199 8.76043 8.33801C8.17024 8.15401 7.27374 8.10871 6.72033 8.23492Z"
			fill="white"
		/>
		<defs>
			<clipPath id="clip0_411_4616">
				<rect width="10" height="10" fill="white" transform="translate(29.0002 3)" />
			</clipPath>
			<clipPath id="clip1_411_4616">
				<rect width="10.6667" height="9.48148" fill="white" transform="translate(15.6662 3.2594)" />
			</clipPath>
		</defs>
	</svg>
);
